import React, { useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { shareInstagramStories } from 'src/app/shared/share/instagramStories';

import type { ShareActionComponentPropsWithOptions } from '../types';

import { useStoriesEducationModal } from './useEducationModal';

// TODO migrate to new DS modal component
export const InstagramStoriesShare: React.FC<ShareActionComponentPropsWithOptions> = ({
	children,
	options,
	onAfterAction,
	onBeforeAction,
}) => {
	const openEducationModal = useStoriesEducationModal();
	const track = useTracking();
	const utilityContext = useUtilityContext();

	const onClick = useMemo(() => {
		return () => {
			void (async () => {
				await onBeforeAction?.();
				const {
					url,
					content: { image },
					trackingData,
					trackingEventName,
				} = options;
				const success = await shareInstagramStories(
					{ url, image },
					{
						trackingData,
						trackingEvents: {
							success: trackingEventName,
							intent: 'instagram_stories_share_story_modal_view',
							continue: 'instagram_stories_share_story_modal_continue',
							cancel: 'instagram_stories_share_story_modal_close',
							failure: `${trackingEventName}_failure`,
						},
						openStoriesEducationModal: ({ onContinueAction, shareVisualPreview }) =>
							openEducationModal({ onContinueAction, shareVisualPreview }),
					},
					track,
					utilityContext,
				);
				await onAfterAction?.(success);
			})();
		};
	}, [onBeforeAction, onAfterAction, options, openEducationModal, track, utilityContext]);

	return React.cloneElement(children, {
		...children.props,
		onClick,
	});
};
